import { type FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router";
import { confirmSignUp, signUp } from "../auth/CognitoClient";

export const Signup = () => {
  const [stage, setStage] = useState<"signup" | "confirm">("signup");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const doSignup = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signUp(email.trim(), password, name.trim() || email.split("@")[0]);
      setStage("confirm");
    } catch (err) {
      setError(err instanceof Error ? err.message : "sign-up failed");
    } finally {
      setBusy(false);
    }
  };

  const doConfirm = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await confirmSignUp(email.trim(), code.trim());
      nav("/login", { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : "confirmation failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="brand">
          <div className="logo">F</div>
          <h1 className="h1" style={{ marginTop: 12 }}>
            {stage === "signup" ? "Create account" : "Verify email"}
          </h1>
        </div>
        {stage === "signup" ? (
          <form className="col gap-16" onSubmit={doSignup}>
            <label className="field">
              Name
              <input value={name} onChange={(e) => setName(e.target.value)} autoComplete="given-name" />
            </label>
            <label className="field">
              Email
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </label>
            <label className="field">
              Password
              <input
                type="password"
                required
                minLength={8}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password"
              />
              <span className="muted">8+ chars with a number and a lowercase letter.</span>
            </label>
            {error && <div className="error">{error}</div>}
            <button className="btn" type="submit" disabled={busy}>
              {busy ? "Creating…" : "Create account"}
            </button>
            <div className="muted" style={{ textAlign: "center" }}>
              Already have an account? <Link to="/login">Sign in</Link>
            </div>
          </form>
        ) : (
          <form className="col gap-16" onSubmit={doConfirm}>
            <div className="muted">We sent a confirmation code to {email}.</div>
            <label className="field">
              Code
              <input value={code} onChange={(e) => setCode(e.target.value)} inputMode="numeric" />
            </label>
            {error && <div className="error">{error}</div>}
            <button className="btn" type="submit" disabled={busy}>
              {busy ? "Verifying…" : "Verify"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};
